import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';

export class CorpAPWorkQueueItemResultDto {
    workQueueId: number;
    apBillId: number;
    managementCompanyId: number;
    managementCompanyName: string;

    @Type(() => Date)
    startTime: Date;

    specialHandling: string;
    isBillCreated: boolean;
    hasNotes: boolean;
    status: string;

    @Type(() => Date)
    lastNotification: Date;

    vendorName: string;
    billNumber: string;
    billAmount: number;
    billStatus: string;
    allowCreateBill: boolean;
    allowUpdateBill: boolean;
    allowUpdateManagementCompany: boolean;
    allowClearManagementCompany: boolean;
    allowApprove: boolean;
    allowDeny: boolean;
    allowSetToPendingApproval: boolean;

    @Type(() => UserNameDisplayResultDto)
    addedBy: UserNameDisplayResultDto;

    @Type(() => UserNameDisplayResultDto)
    approver: UserNameDisplayResultDto;

    @Type(() => FileInfoDisplayResultDto)
    workQueueFileInfo: FileInfoDisplayResultDto;

    get addedByDisplayText(): string {
        return Utils.notNullAndDefined(this.addedBy) ? this.addedBy.displayName : '';
    }
    get approverDisplayText(): string {
        return Utils.notNullAndDefined(this.approver) ? this.approver.displayName : '';
    }

    get hasFileInfo(): boolean {
        return Utils.notNullAndDefined(this.workQueueFileInfo);
    }
}
